import { Stack } from '@mui/material';
import ScreenSizeGuard from 'src/auth/ScreenSizeGuard';
import ProfileProductsContent from 'src/sections/@dashboard/profile/components/ProfileProductsContent';
import { useCurrentVisitContext } from 'src/sections/@dashboard/visit/hooks/useCurrentVisitContext';
import { Roles } from 'src/types/User';

export default function ProfileProductsPage() {
  const { isLoading } = useCurrentVisitContext();

  return (
    <ScreenSizeGuard roles={[Roles.professional]} smallerThan="md">
      <Stack sx={{ height: 1, gap: 3 }}>
        {!isLoading && <ProfileProductsContent />}
      </Stack>
    </ScreenSizeGuard>
  );
}
